import { render, staticRenderFns } from "./PaginatedInvitationList.vue?vue&type=template&id=534c1f36"
import script from "./PaginatedInvitationList.vue?vue&type=script&lang=ts"
export * from "./PaginatedInvitationList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports